export const buildInsightsSearchParams = (params: object, url: string): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params)
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          searchParams.append(`${key}[]`, item);
        });
      } else {
        searchParams.set(key, value.toString());
      }
    });

  return !!searchParams.toString() ? `${url}?${searchParams.toString()}` : url;
};
